import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { clubDetailActions } from './club-detail.actions';
import { map } from 'rxjs/operators';
import { clubActions } from '../../state/club/club.actions';

@Injectable()
export class ClubDetailEffects {
  private readonly actions$ = inject(Actions);

  public readonly joinClub$ = createEffect(() =>
    this.actions$.pipe(
      ofType(clubDetailActions.joinClub),
      map(action => clubActions.joinClub(action))
    )
  );

  public readonly leaveClub$ = createEffect(() =>
    this.actions$.pipe(
      ofType(clubDetailActions.leaveClub),
      map(action => clubActions.leaveClub(action))
    )
  );
}
